/**
 * 방화벽 Batch File
 * Ipv4, Ipv6
 *
 * @since 2018-09-19
 * @author kdydesign.kim
 */
import {
  CommonApiPrefix as cmnApiPrefix,
  SecutiryPolicyApiPrefix as poApiPrefix
} from 'utils'
import {pcDownloadFile} from '~/utils/files'

// 방화벽 정책 - 배치 입력 데이터
const initFwBatchData = () => {
  return {
    file: void 0,
    excel_pos: 1,
    allow_dup: 1,
    start_seq: void 0
  }
}

export const state = () => ({
  upLoadFile: void 0,
  fwBatchHistroyDataList: [],
  fwBatchData: initFwBatchData()
})

export const mutations = {
  // 정책 배치 이력 목록 조회
  getFwBatHistroy (state, data) {
    state.fwBatchHistroyDataList = data
  },

  // 파일 업로드
  fileUpload (state, {file}) {
    state.upLoadFile = file
  }
}

export const actions = {
  // 정책 배치 이력 목록 조회
  async getFwBatHistroy ({commit, state}, {version}) {
    const {code, result} = await this.$axios.$get(`${poApiPrefix}/fw/${version}/rules/batch/history`)

    if (code === 'ok') {
      commit('getFwBatHistroy', result)
    }
  },

  // 정책 배치 이력 목록 다운로드
  async getFwBatHistroyDownload ({commit, state}, {file, version}) {
    const {data, fileName} = await this.$axios.$file(`${poApiPrefix}/fw/${version}/rules/batch/history`, {
      filename: file
    }, {
      responseType: 'blob',
      method: 'post',
      successAlert: false
    })

    pcDownloadFile(data, fileName)
  },

  // 파일 업로드
  async fileUpload ({commit, state}, {formData}) {
    const {code, result} = await this.$axios.$post(`${cmnApiPrefix}/file/import`, formData)

    if (code === 'ok') {
      commit('fileUpload', result)
    }
  },

  // 배치 실행
  async runAddBatch ({commit, state}, {version}) {
    const {code, result} = await this.$axios.$post(`${poApiPrefix}/fw/${version}/rules/batch`, _.assign(state.fwBatchData, {
      file: state.upLoadFile
    }), {
      successAlert: false
    })

    if (code === 'ok') {
      return result
    } else if (code === 'pok' || code === 'nok') {
      return result.errors
    }
  },

  // 정책 비활성/삭제 배치 실행
  async runDisableBatch ({commit, state}, {version}) {
    const {code, result} = await this.$axios.$put(`${poApiPrefix}/fw/${version}/rules/batch`, {
      file: state.upLoadFile
    }, {
      successAlert: false
    })

    if (code === 'ok') {
      return result
    } else if (code === 'pok' || code === 'nok') {
      return result.errors
    }
  }
}

export const getters = {}

export const strict = false
